import { BehaviorSubject } from 'rxjs'
import { Toast } from '../interfaces/Toast'

interface AppState {
  hash$: BehaviorSubject<string>
  toasts$: BehaviorSubject<Toast[]>
  addToast: (message: string, type: 'info' | 'success' | 'warning' | 'error') => void
}

export const appState: AppState = {
  hash$: new BehaviorSubject<string>(window.location.hash),
  toasts$: new BehaviorSubject<Toast[]>([]),
  addToast: (message: string, type: 'info' | 'success' | 'warning' | 'error') => {
    appState.toasts$.next([...(appState.toasts$.value ?? []), { message, type, created: new Date() }])
  }
}

// check for removable toasts every 500ms, remove when older than 5 seconds
setInterval(() => {
  const toasts = appState.toasts$.value
  if (toasts && toasts.length > 0) {
    const now = new Date()
    const newToasts = toasts.filter((t) => now.getTime() - t.created.getTime() < 2000)
    appState.toasts$.next(newToasts)
  }
}, 500)
